module.exports = __webpack_public_path__ + "img/menuDetail4.879de8eb.png";